import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MediaBrowser from '../components/MediaBrowser';
export default function MediaPage() {
    return (_jsxs("main", { className: "media-page-wrap", children: [_jsxs("header", { className: "page-head", children: [_jsx("h1", { children: "Media" }), _jsx("p", { className: "muted small", children: "Upload images, videos, and SVGs. Edit alt text, crop, rotate, set focal points, and clean unused files." })] }), _jsx(MediaBrowser, { pageMode: true })] }));
}
